import { Card, Col, Form, Row } from 'react-bootstrap';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
import qs from 'qs'; // You can install this with `npm install qs`
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import { useEffect, useState } from 'react';
import Button from 'components/base/Button';
import { Course } from '../my_learning/components/DataDefinitions';
import Badge from 'components/base/Badge';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import imageIcon from 'assets/img/th-each-ai/image-placeholder.webp';

const Courses = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Learning'),
            url: '/learning'
        },
        {
            label: t('Courses'),
            active: true
        }
    ];
    const auth = useAuth();
    type MapType = Map<string, string>;

    const [courses, setCourses] = useState<Course[]>([]);
    const [sponsoredCourses, setSponsoredCourses] = useState<Course[]>([]);
    const [topics, setTopics] = useState<string[]>([]);
    const [languages, setLanguages] = useState<string[]>([]);

    const [searchMap, setSearchMap] = useState<MapType>(new Map());

    const [loading, setLoading] = useState(true);

    // Function to convert map to object
    const mapToObject = (map: MapType): Record<string, string> => {
        const obj: Record<string, string> = {};
        map.forEach((value, key) => {
            obj[key] = value;
        });
        return obj;
    };

    const truncateText = (longText: string, maxLength: number = 100) => {
        const truncatedText =
            longText.length > maxLength ? longText.slice(0, maxLength) + '...' : longText;
        return truncatedText;

    };

    const handleSearch = async () => {

        const params = mapToObject(searchMap);
        //params['isCoach'] = isCoach ? '1' : '0';
        //params['isCoachInterno'] = isCoachInterno ? '1' : '0';
        const queryString = qs.stringify(params);
        console.log(queryString);
        try {
            const response = await apiClient.get(
                `/v1/find/coach?${queryString}`,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            //onSearchComplete(response.data);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    const fetchData = async () => {
        try {
            const response = await apiClient.get(
                '/v1/courses',
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            setCourses(response.data.courses);
            setTopics(response.data.topics);
            // Extract languages
            const languages = response.data.courses.map((course: { lang: string; }) => course.lang);

            // Get unique languages
            const uniqueLanguages = [...new Set<string>(languages)];
            setLanguages(uniqueLanguages);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchSponsoredCourses = async () => {
        try {
            const response = await apiClient.get(
                '/v1/sponsored-courses',
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            setSponsoredCourses(response.data.courses);
        } catch (error) {
            console.error('Error fetching sponsored courses:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        fetchSponsoredCourses();
    }, []);


    const handleTopicChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        //onPreferencesChange({ ...preferences, [name]: checked });
    };


    const sponsored_courses = sponsoredCourses.map((course, index) => (
        <Col key={index} xs={4} sm={4} md={4} lg={4} className="my-col mb-4">
            <Card className="m-2">
                <div style={{
                    backgroundImage: (course.picture ? `url("data:image/jpeg;base64, ${course.picture}")` : imageIcon), height: '200px',
                    backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '100%'
                }}>
                </div>


                <Card.Body style={{ height: '15rem' }}>
                    <Card.Title className='fs-9'><Badge variant="phoenix" bg='danger'>{course.topic}</Badge></Card.Title>
                    <Card.Title className='fs-8' style={{ height: '40px' }}>{truncateText(course.title, 80)}</Card.Title>
                    <Card.Text className='fs-9 text-uppercase' >{course.provider}</Card.Text>

                    <Card.Text style={{ height: '120px', overflowY: 'hidden' }}>
                        {truncateText(course.description)}
                    </Card.Text>

                </Card.Body>
                <Card.Footer className='mt-1'>
                    <Button variant="primary">{t('Courses.visit_url')}<FontAwesomeIcon
                        icon={faExternalLink}
                        className="px-1 fs-10"
                    />
                    </Button>
                </Card.Footer>
            </Card>
        </Col >
    ));

    const course_topics = topics.map((topic, index) => (
        <Form.Check key={index} className="mt-2 mb-2 mx-1 me-1 fs-7"
            type='checkbox'
            label={topic}
        />
    ));

    const course_languages = languages.map((lang, index) => (
        <Form.Check key={index} className="mt-2 mb-2 mx-1 me-1 fs-7"
            type='checkbox'
            label={t('Courses.lang_' + lang)}
        />
    ));



    const filtered_courses = courses.map((course, index) => (
        <Col key={index} xs={4} sm={4} md={4} lg={4} className="my-col mb-4">
            <Card className="m-2">
                <div style={{
                    backgroundImage: (course.picture ? `url("data:image/jpeg;base64, ${course.picture}")` : imageIcon), height: '200px',
                    backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '100%'
                }}>
                </div>

                <Card.Body style={{ height: '15rem' }}>
                    <Card.Title className='fs-9'><Badge variant="phoenix" bg='danger'>{course.topic}</Badge></Card.Title>
                    <Card.Title className='fs-8' style={{ height: '40px' }}>{truncateText(course.title, 80)}</Card.Title>

                    <Card.Text className='fs-8 text-uppercase' >{course.provider}</Card.Text>
                    <Card.Text style={{ height: '120px', overflowY: 'hidden' }}>
                        {truncateText(course.description)}
                    </Card.Text>
                </Card.Body>
                <Card.Footer className='mt-1'>
                    <Button variant="primary">{t('Courses.visit_url')}<FontAwesomeIcon
                        icon={faExternalLink}
                        className="px-1 fs-10"
                    /></Button>
                </Card.Footer>
            </Card>
        </Col>
    ));

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />
            <h2 className="mt-4 mb-4">{t('Courses.trending')}</h2>

            <Row className="p-4 theachai-overflow-x-scroll flex-nowrap">
                {sponsored_courses}
            </Row>

            <h2 className="mt-4 mb-4 ">{t('Courses.available_courses')}</h2>


            <Row className='mt-4'>
                <Col xs={2} className="">
                    <div className="d-flex flex-column p-2 mb-2 bg-white">
                        <h3 className="p-2">{t('Courses.filter_by')}</h3>
                        <h4 className="p-2">{t('Courses.topic')}</h4>
                        {course_topics}
                        <h4 className="p-2">{t('Courses.language')}</h4>
                        {course_languages}
                    </div>
                </Col>
                <Col xs={10} className="">
                    <Row>
                        {filtered_courses}
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default Courses;
